<template>
  <section class="grid-flex column">
    <div class="flex w100">
      <div class="box">
        <div class="box-title flex middle">
          <div>
            <h3>Taxa de trackeamento</h3>
          </div>
          <div class="flex-1 flex end filters-groupo-holder">
            <div class="flex between middle">
              <ltk-date-picker
              label="Filtro de data"
              v-model="filters.data.date"
              :loading="loading"
            ></ltk-date-picker>
            </div>
          </div>
        </div>
        <div class="box-content">
          <div v-if="loading">
            <content-loading>
              <fake-line height="30"></fake-line>
              <fake-line height="30"></fake-line>
              <fake-line height="30"></fake-line>
              <fake-line height="30"></fake-line>
            </content-loading>
          </div>

          <div class="flex center">
            <div class="flex center column middle">
              <h1 class="rate"><span>{{ taxRate }}</span> / 100</h1>
              <p class="margin-top-l">A nota de trackeamento serve para ter ideia de como está a cobertura dos seus dados.</p>
              <p class="margin-top-l"><b>Atenção:</b> Uma nota acima de <b>70</b> é considerada muito boa.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import moment from "moment";
moment.locale("pt-br");

import {
  getTraxTracker,
} from "@/services/taxtracker";

import ltkDatePicker from "@/components/datepicker/LtkDatePicker";

export default {
  name: "tax-tracker",
  components: {
    ltkDatePicker
  },
  props: [],
  data() {
    return {
      loading: false,
      taxRate: '-',
      filters: {
        data: {
          date: [
            moment()
              .add(-30, "d")
              .startOf("day")
              .toDate(),
            moment()
              .startOf("day")
              .toDate(),
          ],
        },
        list: {
        },
      },
    };
  },
  mounted() {
    this.getTraxTracker()
  },
  watch: {
    "filters.data": {
      deep: true,
      handler() {
        this.taxRate = '-'
        this.getTraxTracker();
      },
    },
  },
  methods: {
    getTraxTracker() {
      const date = this.filters.data.date;
      let params = {
        start_date: date[0] ? date[0].toISOString().slice(0, 10) : "",
        end_date: date[1] ? date[1].toISOString().slice(0, 10) : "",
      }
      getTraxTracker(params)
        .then((result) => {
          this.taxRate = result.tax
        })
        .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }
          this.$toast.error({
            title:'Erro',
            message:'Ocorreu algum problema'
          })
        })
    }
  }
};
</script>

<style lang="scss" scoped>

.rate {
  font-size: 48px;
  span {
    color: var(--primary)
  }

}
</style>
